import { useState, useEffect } from "react";
import { adminListDataApiEndPoint, contactSupportsApi } from "@/apis/apis";
import { columns } from "./Columns";
import BaseTable from "../BaseTable";
import { useSearchParams } from "react-router-dom";
import {
  TAB,
  contactSupportStatusFilters,
} from "@/constant/ContactSupport/status";
import { FILTER_TYPE } from "@/constant/constants";
import { useGet } from "@/apiHooks/HttpFunctions";
import { Loader } from "@/components/Loader";

export default function SupportTicketsPage() {
  const tabs = [
    {
      id: "tab-1",
      label: "Open - Unread | Open - Unreplied",
    },
    {
      id: "tab-2",
      label: "Open - Waiting | Closed - Solved | Closed - Inactivity",
    },
  ];

  const [activeTab, setActiveTab] = useState(tabs[0]);
  const [searchParams, setSearchParams] = useSearchParams();
  const targetTab = searchParams.get("filter[tab]") || TAB.TAB_1;

  useEffect(() => {
    if (targetTab) {
      setSearchParams((prevParams) => {
        const newParams = new URLSearchParams(prevParams);
        newParams.set("filter[tab]", targetTab);
        return newParams;
      });
    }
  }, [targetTab, setSearchParams]);

  const handleTab = (event, tab) => {
    setSearchParams((prevParams) => {
      const newParams = new URLSearchParams(prevParams);
      newParams.set("filter[tab]", tab);
      return newParams;
    });

    setActiveTab(tabs.find((t) => t.id === tab));
  };

  const statusOptions = [
    { value: "", label: "All" },
    ...(contactSupportStatusFilters?.map((status) => ({
      value: status.value,
      label: status.label,
    })) || []),
  ];

  const additionalFilters = [
    {
      id: "filter[contact_support_status]",
      label: "Status",
      type: FILTER_TYPE.SELECT,
      options: statusOptions,
    },
  ];

  const { data: userOptions, showIsFetching } = useGet({
    apiURL: adminListDataApiEndPoint,
    enabled: true,
  });

  if (showIsFetching) {
    return (
      <div className="flex flex-1 items-center justify-center">
        <Loader />
      </div>
    );
  }

  return (
    <div>
      {/* Tabs */}
      <ul className="flex text-sm font-medium text-center text-white border-b-2 border-gray-100 mt-2 mb-3 w-full">
        {tabs.map((tab) => (
          <li key={tab.id}>
            <button
              type="button"
              className={`px-4 py-2 w-full rounded-t-lg ${
                activeTab.id === tab.id
                  ? "bg-gray-100 text-black"
                  : "text-gray-500 hover:bg-gray-100"
              }`}
              onClick={(e) => handleTab(e, tab.id)}
            >
              {tab.label}
            </button>
          </li>
        ))}
      </ul>

      {/* Table */}
      <BaseTable
        label="Support Tickets"
        apiURL={contactSupportsApi}
        columns={columns(userOptions, showIsFetching)}
        enableAdd={false}
        allColumns={columns()}
        additionalFilters={additionalFilters}
      />
    </div>
  );
}
